import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import parse from "html-react-parser";
import getSettings from "../../../controllers/settings/getSettings";
import { db } from "../../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { getLocalStorageItem } from "../../../controllers/localStorage/getLocalStorage";
import FormatPriceNumeral from "../../../helpers/FormatPriceNumeral";
import FormatPriceVerbal from "../../../helpers/FormatPriceVerbal";

const Preview = (props) => {
  let { modalStatus, setModalStatus, template, property } = props;
  const handleClose = () => {
    setModalStatus(false);
  };
  const [bDetails, setBDetails] = useState({});
  const [mCurrencySettings, setMCurrencySettings] = useState({});
  useEffect(() => {
    async function fetchData() {
      const clientDocument = await doc(
        db,
        "clients",
        getLocalStorageItem("bid")
      );
      const clientSnapshot = await getDoc(clientDocument);
      const client = { id: clientSnapshot.id, ...clientSnapshot.data() };
      setBDetails(client);
      const settings = await getSettings();
      setMCurrencySettings(settings);
    }
    fetchData();
  }, []);

  const options = {
    replace: ({ attribs }) => {
      if (!attribs) {
        return;
      }

      if (attribs.id === "PropertyName") {
        return <span id="PropertyName"> {property?.propertyTitle}</span>;
      }
      if (attribs.id === "PropertyPrice") {
        return (
          <span id="PropertyPrice">
            {mCurrencySettings.currency}
            {`
              ${
                mCurrencySettings.currencyFormat === "numeral"
                  ? property?.rentalPrice > 0
                    ? FormatPriceNumeral(property?.rentalPrice)
                    : FormatPriceNumeral(property?.sellingPrice)
                  : property?.rentalPrice > 0
                  ? FormatPriceVerbal(property?.rentalPrice)
                  : FormatPriceVerbal(property?.sellingPrice)
              }`}
          </span>
        );
      }
      if (attribs.id === "PropertyAddress") {
        return <span id="PropertyAddress"> {property?.propertyTitle}</span>;
      }
      if (attribs.id === "PropertyCity") {
        return <span id="PropertyCity"> {property?.city}</span>;
      }
      if (attribs.id === "PropertyDescription") {
        return (
          <span id="PropertyDescription">
            {property?.description?.length > 100
              ? property?.description?.slice(0, 100) + "...."
              : property?.description}
          </span>
        );
      }
      if (attribs.id === "propertyImage") {
        return (
          <img
            id="propertyImage property-img-email"
            class="adapt-img"
            src={
              property?.images?.length > 0
                ? property?.images[0]
                : `https://actdwm.stripocdn.email/content/guids/CABINET_a5ab9a577b8b948a7d2025679ccd1afe386319fac48ed8002beb9f53098ca24b/images/architecture5339245__340.jpg`
            }
            width="200"
            height="200"
          />
        );
      }
      if (attribs.id === "businessLogo") {
        return (
          <img
            class="adapt-img logo-img-email"
            id="businessLogo"
            src={
              bDetails?.image_url
                ? bDetails?.image_url
                : "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Image_created_with_a_mobile_phone.png/220px-Image_created_with_a_mobile_phone.png"
            }
            width="50"
            height="50"
          />
        );
      }
    },
  };

  return (
    <Modal
      open={modalStatus ? true : false}
      onClose={handleClose}
      className="ModalStyle add-edit-client-modal"
    >
      <div
        className="modal-dialog modal-lg
        email-template-preview-modal
      "
      >
        <div className="email-template-content">
          <div className="btn-container">
            <div className="preview-label">
              <h2>Preview</h2>
            </div>
            <button
              type="button"
              className="close add-edit-client-modal-close-button d-none"
              onClick={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <span>&times;</span>
            </button>
          </div>
          <div className="parse-html-style">
            {parse(template.html, options)}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default Preview;
